import type React from "react";
import type { ReactNode } from "react";
import { getEnv } from "../../env";
import AktLogo from "../../gfx/akt-logo";
import RuterLogo from "../../gfx/ruterbedrift-logo";
import useTheme from "../../hooks/useTheme";
import "./WidgetWrapper.scss";

interface Props {
	children: ReactNode;
}

const WidgetWrapper: React.FC<Props> = ({ children }) => {
	const theme = useTheme();
	const env = getEnv();
	return (
		<div
			className={`storkunde-widget ${theme}`}
			data-test-id="storkunde-widget"
		>
			<div data-test-id="logo" className="logo">
				{env.tenant === "ruter" && <RuterLogo />}
				{env.tenant === "akt" && (
					<div className="akt-logo">
						<AktLogo />
					</div>
				)}
			</div>

			<div>{children}</div>
		</div>
	);
};

export default WidgetWrapper;
